import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CyberMonochrome from './Home';
import PrivacyPolicy from './PrivacyPolicy';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<CyberMonochrome />} />
        <Route path="/privacidade" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;